import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SharedModule } from '../../../_shared/shared.module';
import { AbilityService } from '../../../_shared/services/ability.service';
import { UtilService } from '../../../_shared/services/util.service';

import { LanguageService } from '../../../languages/shared/language.service';

import { WhatToBring } from '../../shared/what-to-bring.model';
import { WhatToBringService } from '../../shared/what-to-bring.service';
import { WhatToBringListComponent } from '../../what-to-bring-list/what-to-bring-list.component';
import { WhatToBringDetailComponent } from '../../what-to-bring-detail/what-to-bring-detail.component';

@Component({
  selector: 'app-what-to-brings-modal',
  templateUrl: './what-to-brings-modal.component.html',
  standalone: true,
  imports: [SharedModule, WhatToBringListComponent, WhatToBringDetailComponent],
})
export class WhatToBringsModalComponent {
  constructor(
    private whatToBringService: WhatToBringService,
    private languageService: LanguageService,
    private abilityService: AbilityService,
    private utilService: UtilService,
    private ref: MatDialogRef<WhatToBringsModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data
  ) {
    // use it onInit ??
    this.getAdditionalLanguages();
  }

  // @Output() private dialogSaved = new EventEmitter<any>(); // avoid closing the dialog

  modalTitle = this.data.title;
  // lang = this.data.params.lang;

  whatToBrings: WhatToBring[];
  meta = [];
  whatToBring: WhatToBring;
  mode = '';
  loadingWhatToBrings = false;

  listMode = true;
  detailMode = false;

  permissions = {
    canList: this.abilityService.can('index_whattobring_accountadmin'),
    canCreate: this.abilityService.can('create_whattobring_accountadmin'),
  };

  defaultLanguage: any;

  private filterCriteria = this.whatToBringService.getFilterCriteria();
  additionalLanguages = [];

  showWhatToBrings() {
    this.modalTitle = this.data.title;

    this.listMode = true;
    this.detailMode = false;

    this.getWhatToBrings();
  }

  addWhatToBring() {
    this.modalTitle = 'ADD_WHAT_TO_BRING';
    this.listMode = false;
    this.detailMode = true;

    this.whatToBring = {};
  }

  // Referenced from app-what-to-bring-detail
  onSavedWhatToBring(whatToBring) {
    this.whatToBring = whatToBring;

    this.listMode = true;
    this.detailMode = false;

    this.getWhatToBrings(whatToBring);
  }

  // Referenced from app-what-to-bring-detail
  onCanceledWhatToBring() {
    this.showWhatToBrings();
  }

  close() {
    this.ref.close(true);
  }

  // Referenced from app-what-to-bring-list
  onSelectedWhatToBring({ whatToBring, mode = '' }) {
    this.whatToBring = whatToBring;
    this.mode = mode;

    this.modalTitle = 'WHAT_TO_BRING';
    this.listMode = false;
    this.detailMode = true;
  }

  private getWhatToBrings(selectedWhatToBring = null) {
    this.filterCriteria.lang = this.defaultLanguage.lang;
    // this.filterCriteria['skip_check_role'] = true;

    this.loadingWhatToBrings = true;
    this.whatToBringService.getWhatToBrings(this.filterCriteria).subscribe((response) => {
      this.whatToBrings = response.data;
      this.meta = response.meta;

      this.loadingWhatToBrings = false;

      if (selectedWhatToBring) {
        this.utilService.changeItemRowStyle(selectedWhatToBring.id);
      }
    });
  }

  private getAdditionalLanguages() {
    this.languageService.getLanguages({ skip_check_role: true }).subscribe((response) => {
      this.defaultLanguage = response.data.find((language) => language.is_default);
      this.additionalLanguages = response.data.filter((language) => !language.is_default);

      this.getWhatToBrings();
    });
  }
}
